/**
 * This file is currently not in use
 **/
import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { WfDataSummary } from 'src/api/wf/models/WfDataSummary';

export const getWfDataSummaryColumns = (t: TFunction): TableColumn<WfDataSummary>[] => [
  {
    name: t('wf.dataSummary.no'),
    selector: (_row, index) => (index ?? 0) + 1,
    width: '70px',
    center: true,
  },
  {
    name: t('wf.dataSummary.salesOfficeName'),
    selector: (row) =>
      row.salesOfficeCode && row.salesOfficeName
        ? `${row.salesOfficeCode} ${row.salesOfficeName}`
        : row.salesOfficeName || row.salesOfficeCode || '',
    sortable: true,
    minWidth: '160px',
  },
  {
    name: t('wf.dataSummary.jobTitleCode'),
    selector: (row) => row.jobTitleCode,
    sortable: true,
    center: true,
  },
  {
    name: t('wf.dataSummary.maintainedUnits'),
    selector: (row) => row.maintainedUnitsAtSalesOfficeCount,
    sortable: true,
    width: '150px',
    right: true,
  },
  {
    name: (
      <div className="flex w-full flex-col items-center rounded-md bg-red-500 py-1 text-center text-white">
        <span className="font-semibold">{t('wf.dataSummary.lockedUp')}</span>
        <div className="flex w-full justify-center space-x-2 px-4 text-sm">
          <span>{t('wf.dataSummary.occurrences')}</span>
          <span>|</span>
          <span>{t('wf.dataSummary.rescues')}</span>
        </div>
      </div>
    ),
    cell: (row) => (
      <div className="flex w-full justify-between px-4">
        <span>{row.lockedUpOccurrencesCount}</span>
        <span>|</span>
        <span>{row.lockedUpRescuesCount}</span>
      </div>
    ),
    sortable: false,
    width: '200px',
    center: true,
  },
  {
    name: (
      <div className="flex w-full flex-col items-center rounded-md bg-blue-500 py-1 text-center text-white">
        <span className="font-semibold">{t('wf.dataSummary.recoveryStatus')}</span>
        <div className="flex w-full justify-between px-4 text-sm">
          <span>{t('wf.dataSummary.required')}</span>
          <span>|</span>
          <span>{t('wf.dataSummary.recovered')}</span>
          <span>|</span>
          <span>{t('wf.dataSummary.unrecovered')}</span>
          <span>|</span>
          <span>{t('wf.dataSummary.workTime')}</span>
        </div>
      </div>
    ),
    cell: (row) => (
      <div className="flex w-full justify-between px-4">
        <span>{row.itemsRequiringHandlingCount}</span>
        <span>|</span>
        <span>{row.recoveredItemsCount}</span>
        <span>|</span>
        <span>{row.unRecoveredItemsCount}</span>
        <span>|</span>
        <span>{row.unRecoveredEstimatedWorkTime}</span>
      </div>
    ),
    sortable: false,
    width: '400px',
    center: true,
  },
];

export const customStyles: TableStyles = {
  headCells: {
    style: {
      borderRight: '1px solid #e5e7eb', // Tailwind gray-200
    },
  },
  cells: {
    style: {
      borderRight: '1px solid #e5e7eb',
    },
  },
};
